var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"messages"},_vm._l((_vm.messageList),function(m){return _c('div',{key:m._id,staticClass:"message",domProps:{"innerHTML":_vm._s(_vm.nl2br(m.message))}})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }